import { render, staticRenderFns } from "./AppNotLiveEx.vue?vue&type=template&id=890d82c8&scoped=true&shadow"
import script from "./AppNotLiveEx.vue?vue&type=script&lang=js&shadow"
export * from "./AppNotLiveEx.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "890d82c8",
  null
  ,true
)

export default component.exports